export const DEFAULT_CHATBOT_MESSAGES = {
    // 1. Initial greeting message when chatbot starts
    bot_initial_message: 'お問い合わせありがとうございます。お困りごとの種類を教えてください。',
    
    // 2. Prompt to select first tag field/category
    bot_first_selection_prompt: 'どの項目から調べますか？',
    
    // 2a. Prompt to select first tag field/category (AI mode)
    bot_first_selection_prompt_ai: '質問を入力してください。または、選択肢を選んで質問をすると、より正確に回答を得ることができます。',
    
    // 3. Back button label
    bot_back_button_label: '< 戻る',
    
    // 4. Prompt to select item from tag field (supports {{SelectedItem}} variable)
    bot_selection_prompt: '{{SelectedItem}}を選択してください。',
    
    // 4a. Prompt to select item from tag field (AI mode - allows text input)
    bot_selection_prompt_ai: '{{SelectedItem}}を選択肢から選択、または質問を入力してください。',
    
    // 5. Skip button label
    bot_skip_button_label: 'スキップ >',
    
    // 6. Message input placeholder (default - step 1, display category)
    bot_chat_input_placeholder: 'お困りごとを選んでください',
    
    // 6a. Message input placeholder for AI mode (when category selected)
    bot_chat_input_placeholder_ai: '話し言葉で質問できます',
    
    // 6b. Message input placeholder for normal mode (step 2 onwards)
    bot_chat_input_placeholder_normal: 'あなたのメッセージ',

    // 6c. Message input placeholder for live chat mode
    bot_live_chat_input_placeholder: 'あなたのメッセージ...',
    
    // 7. End message after chat completion
    bot_end_message: 'ご利用ありがとうございました。',
    
    // 8. Confirmation message asking if issue is resolved
    bot_confirm_resolved: '問題は解決しましたか？',
    
    // 9. Prompt to fill QA form
    bot_form_qa_prompt: '必要事項を入力して、問い合わせを発行します。',
    
    // 10. Message showing number of knowledge found (supports {{totalKnowledge}} variable)
    bot_knowledge_found: '{{totalKnowledge}}件のナレッジが見つかりました',
    
    // 10a. Message showing number of knowledge found (AI mode - with instruction)
    bot_knowledge_found_ai: '{{totalKnowledge}}件のナレッジが見つかりました。回答につながるものがあれば、クリックしてご覧ください。',
    
    // 11. Button to restart chat from beginning
    bot_restart_chat: '始めからチャットを開始',
    
    // 12. Hint for additional options in input box
    bot_other_options_hint: '※その他の選択肢は下の入力ボックスから選んでください。',
    
    // 13. Yes button label for confirmation
    bot_confirm_yes_label: 'はい',
    
    // 14. No button label for confirmation
    bot_confirm_no_label: 'いいえ',

    // 15. Message when AI responds in preview mode (ChatBox.js)
    bot_ai_preview_response: 'こちらはAIからの回答です。',

    // 16. Thank you message after QA form submission (BackToBeginMessage.js)
    bot_thank_you_message: 'お問い合わせありがとうございました。担当者より改めてご連絡させていただきます。',

    // 17. Message when connecting to agent (live chat)
    bot_connecting_message: 'エージェントと接続しています。',

    // 18. Message when connected to agent (live chat)
    bot_connected_message: 'エージェントと接続しました。',

    // 19. Message when no agent is available (live chat)
    bot_not_found_agent_message: '大変申し訳ございません。ただ今担当者が不在中ため、対応しかねます。',

    // 20. Message when live chat ends
    bot_end_live_chat_message: 'ライブチャットが終わりました。',

    // 21. Prompt to suggest using AI
    bot_suggest_using_ai_message: '質問を入力してください。',

    // 22. Prompt for QA form in live chat mode
    bot_qa_form_live_chat_prompt: '必要事項を入力して、ライブチャットを始めます。',

    // 23. Message when inquiry submission is cancelled
    bot_inquiry_cancelled_message: '問い合わせの発行はキャンセルされました。',

    // Additional messages for form fields (optional customization)
    // These are used in QA form when creating tickets
    form_email_label: 'メールアドレス',
    form_email_placeholder: 'メールアドレスを入力してください',
    form_email_confirm_label: 'メールアドレス（確認用）',
    form_name_label: '氏名',
    form_name_kana_label: 'フリガナ',
    form_last_name_label: '姓',
    form_last_name_placeholder: '姓を入力してください。',
    form_first_name_label: '名',
    form_first_name_placeholder: '名を入力してください。',
    form_last_name_kana_label: '姓（カナ）',
    form_last_name_kana_placeholder: '姓（カナ）を入力してください。',
    form_first_name_kana_label: '名（カナ）',
    form_first_name_kana_placeholder: '名（カナ）を入力してください。',
    form_submit_button: '送信',
    form_cancel_button: 'キャンセル',

    // Validation error messages for QA form (supports variable substitution)
    // These messages are used when form validation fails
    // Updated to match standard locale keys (COMMSG014, COMM01MSG07, COMMSG022, COMMSG036)
    form_invalid_msg_required: 'このフィールドは入力必須です。',
    form_invalid_msg_email_invalid: 'メール形式が正しくありません。',
    form_invalid_msg_email_max_length: '{{maxLength}}文字以下で入力してください。',
    form_invalid_msg_email_confirm_mismatch: '確認用メールアドレスが一致しません。',
    form_invalid_msg_name_max_length: '{{maxLength}}文字以下で入力してください。'
};

/**
 * Mapping from old locale keys to new message config keys
 * Used for migration and backward compatibility
 */
export const LOCALE_KEY_MAPPING = {
    'CBOTMSG001': 'bot_initial_message',
    'CBOTMSG002': 'bot_first_selection_prompt',
    'CBOTMSG002-AI-ON': 'bot_first_selection_prompt_ai',
    'CBOTMSG003': 'bot_selection_prompt',
    'CBOTMSG003-AI-ON': 'bot_selection_prompt_ai',
    'CBOTMSG004': 'bot_knowledge_found',
    'CBOTMSG004-AI-ON': 'bot_knowledge_found_ai',
    'CBOTMSG005': 'bot_other_options_hint',
    'CBOTMSG006': 'bot_end_message',
    'CBOTMSG011': 'bot_form_qa_prompt',
    'CBOTMSG012': 'bot_not_found_agent_message',
    'CBOTMSG013': 'bot_inquiry_cancelled_message',
    'CBOTMSG016': 'bot_connecting_message',
    'CBOTMSG018': 'bot_end_live_chat_message',
    'CBOTMSG019': 'bot_connected_message',
    'CBOTLB001': 'bot_confirm_resolved',
    'CBOTLB009': 'bot_form_qa_prompt',
    'CBOTLB014': 'bot_qa_form_live_chat_prompt',
    'CBOTBT004': 'bot_restart_chat',
    'COMBTN002': 'bot_confirm_yes_label',
    'COMBTN007': 'bot_confirm_no_label',
    'CBOTP001': 'bot_chat_input_placeholder',
    'MESSAGE_SUGGEST_USING_AI': 'bot_suggest_using_ai_message',
    'MSG-AI-ALLOW-ASK-IN-SPOKEN-LANGUAGE': 'bot_chat_input_placeholder_ai',
    'MSG-NORMAL-ASK-IN-SPOKEN-LANGUAGE': 'bot_chat_input_placeholder_normal',
    'MSG-AI-RESPOND-TO-USER-MSG-ON-PREVIEW-KNOW-ROBO': 'bot_ai_preview_response',
    'USER11MSG001': 'bot_thank_you_message',
    'USER11LB002': 'form_email_label',
    'USER11LB011': 'form_name_label',
    'USER11LB012': 'form_name_kana_label',
    'USER11P001': 'form_email_placeholder',
    'USER11LB004': 'form_last_name_label',
    'USER11LB005': 'form_first_name_label',
    'USER11LB006': 'form_last_name_kana_label',
    'USER11LB007': 'form_first_name_kana_label',
    'USER04BTN001': 'form_submit_button',
    'COMBTN001': 'form_cancel_button'
};

/**
 * Default message configuration JSON object
 * This is the complete structure with all configurable messages
 * Used as initial default for messageConfig input field
 */
export const DEFAULT_MESSAGE_CONFIG_OBJECT = {
    scope: 'KnowledgeRobo',
    default_language: 'ja',
    messages: {
        ja: {
            bot_initial_message: 'お問い合わせありがとうございます。お困りごとの種類を教えてください。',
            bot_first_selection_prompt: 'どの項目から調べますか？',
            bot_first_selection_prompt_ai: '質問を入力してください。または、選択肢を選んで質問をすると、より正確に回答を得ることができます。',
            bot_selection_prompt: '{{SelectedItem}}を選択してください。',
            bot_selection_prompt_ai: '{{SelectedItem}}を選択肢から選択、または質問を入力してください。',
            bot_back_button_label: '< 戻る',
            bot_skip_button_label: 'スキップ >',
            bot_knowledge_found: '{{totalKnowledge}}件のナレッジが見つかりました',
            bot_knowledge_found_ai: '{{totalKnowledge}}件のナレッジが見つかりました。回答につながるものがあれば、クリックしてご覧ください。',
            bot_confirm_resolved: '問題は解決しましたか？',
            bot_confirm_yes_label: 'はい',
            bot_confirm_no_label: 'いいえ',
            bot_other_options_hint: '※その他の選択肢は下の入力ボックスから選んでください。',
            bot_form_qa_prompt: '必要事項を入力して、問い合わせを発行します。',
            form_email_label: 'メールアドレス',
            form_email_placeholder: 'メールアドレスを入力してください',
            form_email_confirm_label: 'メールアドレス（確認用）',
            form_name_label: '氏名',
            form_name_kana_label: 'フリガナ',
            form_last_name_label: '姓',
            form_last_name_placeholder: '姓を入力してください。',
            form_first_name_label: '名',
            form_first_name_placeholder: '名を入力してください。',
            form_last_name_kana_label: '姓（カナ）',
            form_last_name_kana_placeholder: '姓（カナ）を入力してください。',
            form_first_name_kana_label: '名（カナ）',
            form_first_name_kana_placeholder: '名（カナ）を入力してください。',
            form_submit_button: '送信',
            form_cancel_button: 'キャンセル',
            bot_thank_you_message: 'お問い合わせありがとうございました。担当者より改めてご連絡させていただきます。',
            bot_end_message: 'ご利用ありがとうございました。',
            bot_restart_chat: '始めからチャットを開始',
            bot_ai_preview_response: 'こちらはAIからの回答です。',
            bot_chat_input_placeholder: 'お困りごとを選んでください',
            bot_chat_input_placeholder_ai: '話し言葉で質問できます',
            bot_chat_input_placeholder_normal: 'あなたのメッセージ',
            bot_connecting_message: 'エージェントと接続しています。',
            bot_connected_message: 'エージェントと接続しました。',
            bot_not_found_agent_message: '大変申し訳ございません。ただ今担当者が不在中ため、対応しかねます。',
            bot_end_live_chat_message: 'ライブチャットが終わりました。',
            bot_suggest_using_ai_message: '質問を入力してください。',
            bot_qa_form_live_chat_prompt: '必要事項を入力して、ライブチャットを始めます。',
            bot_inquiry_cancelled_message: '問い合わせの発行はキャンセルされました。',
            bot_live_chat_input_placeholder: 'あなたのメッセージ...',
            form_invalid_msg_required: 'このフィールドは入力必須です。',
            form_invalid_msg_email_invalid: 'メール形式が正しくありません。',
            form_invalid_msg_email_max_length: '{{maxLength}}文字以下で入力してください。',
            form_invalid_msg_email_confirm_mismatch: '確認用メールアドレスが一致しません。',
            form_invalid_msg_name_max_length: '{{maxLength}}文字以下で入力してください。',
        }
    }
};
